export type FeedbackProduct = { name?: string | null } | string | null;

export const getFeedbackProductName = (product?: FeedbackProduct): string => {
    // 转换后的型号字段可能直接返回品牌名或 PC；空值统一显示“其它”。
    const name = typeof product === 'string' ? product : product?.name;
    return name?.trim() || '其它';
};
